import { A11yModule } from '@angular/cdk/a11y';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconModule } from 'src/app/icon/icon.module';

@Component({
  selector: 'app-auth-drawer',
  imports: [A11yModule, TranslateModule, IconModule],
  templateUrl: './auth-drawer.component.html'
})
export class AuthDrawerComponent {
  @Input() heading: string;
  @Input() description?: string;
  @Output() closed = new EventEmitter<void>();

  @HostListener('document:keydown.escape')
  onEscape() {
    this.closed.emit();
  }
}
